import "./Spinner.scss";

function Spinner({ text }) {
  return (
    <div className="spinner">
      <div className="backdrop">
        <span className="loader"></span>
        {text && <p className="spinner-text">{text}</p>}
      </div>
    </div>
  );
}

export default Spinner;
